import React, { useContext, useState } from 'react';
import axios from 'axios';

//styles
import styles from './NewUserModal.module.scss';

//functions
import { notify } from '../functions/toasts';

import jalaliMoment from 'jalali-moment';

import MyDatePicker from './MyDatePicker';

import persianToEnglishNumber from './persianToEnglishNumber';
import { myUserDataContext } from '../App';

function DownloadExcelModal() {
  // const baseUrlExcel = document.getElementById("baseUrlExcel").value;
  const baseUrlExcel = process.env.REACT_APP_BASE_URL;

  const [state, setState] = useState({
    objectKey: '',
  });

  const [EndState, setEndState] = useState({
    objectKey: '',
  });

  const numberInEnglish = persianToEnglishNumber(state.objectKey);
  const gregorianDate = jalaliMoment(numberInEnglish, 'jYYYY/jMM/jDD')
    .locale('en')
    .format('YYYY/MM/DD');
  const FixTimeEndStart = gregorianDate.replace(/\//g, '-');

  const numberInEnglishEndState = persianToEnglishNumber(
    EndState.objectKey
  );
  const gregorianDateEndState = jalaliMoment(
    numberInEnglishEndState,
    'jYYYY/jMM/jDD'
  )
    .locale('en')
    .format('YYYY/MM/DD');
  const FixTimeEnd = gregorianDateEndState.replace(/\//g, '-');

  const [checkBtnDownload, setCheckBtnDownload] = useState(false);

  const data = useContext(myUserDataContext);
  const { userData } = data;
  const { token } = userData;

  //for download excel handler
  const downloadHandler = () => {
    const date1 = new Date(FixTimeEndStart);
    const date2 = new Date(FixTimeEnd);
    const differenceInMilliseconds = date2 - date1;
    const daysDifference =
      differenceInMilliseconds / (1000 * 60 * 60 * 24);

    if (daysDifference > 7) {
      notify('بازه زمانی بیشتر از ۷ روز است', 'error');
    } else {
      setCheckBtnDownload(true);
      axios({
        url: `${baseUrlExcel}api/landing-extra/excel-download-by-date?start_date=${FixTimeEndStart} 00:00:00&end_date=${FixTimeEnd} 23:59:59`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      })
        .then((res) => {
          if (res && res.data instanceof Blob) {
            const url = window.URL.createObjectURL(
              new Blob([res.data])
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `landingExtra.xlsx`); // نام دلخواه برای فایل با پسوند Excel

            document.body.appendChild(link);
            link.click();
            link.remove();
            setCheckBtnDownload(false);
            document.getElementById('closeNewUserModal').click();
            notify('انجام شد', 'success');
          } else {
            console.log(res);
            notify('خطا در دریافت فایل اکسل', 'error');
            setCheckBtnDownload(false);
          }
        })
        .catch((error) => {
          console.log(error);
          notify('خطا در دریافت فایل اکسل', 'error');
          setCheckBtnDownload(false);
        });
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="newUserModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                دانلود اکسل{' '}
              </h1>
            </div>
            <div className="modal-body">
              <div className={styles.divNewUser}>
                <div
                  style={{ display: 'flex', placeContent: 'center' }}
                >
                  <label>
                    از تاریخ
                    <br />
                    <MyDatePicker
                      state={state}
                      setState={setState}
                      objectKey="objectKey"
                    />
                  </label>

                  <label style={{ marginRight: '4%' }}>
                    تا تاریخ
                    <br />
                    <MyDatePicker
                      state={EndState}
                      setState={setEndState}
                      objectKey="objectKey"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div
              className="modal-footer"
              style={{ direction: 'ltr' }}
            >
              <button
                type="button"
                className="btn btn-secondary"
                id="closeNewUserModal"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={downloadHandler}
                disabled={checkBtnDownload}
              >
                دانلود
                {checkBtnDownload ? (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  <i className="bi bi-file-spreadsheet-fill me-2"></i>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DownloadExcelModal;
